module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }